/* eslint-disable no-prototype-builtins */
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Form, Table } from 'react-bootstrap';
import Descriptions from '@uiw/react-descriptions';
import { loaderActions } from '../../../../features/Loader/LoaderSlice';
import { toast } from 'react-hot-toast';
import { useCurrentCompanyID } from '../../../../hooks/useCurrentCompany';
import { LoadReceipt, LoadReceiptLines } from '../../../../features/Receipt/ReceiptSlice';

function PurchaseReceiptId() {
  const { id, vendorType } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const companyId = useCurrentCompanyID();

  const { fetchingReceipt, currentReceipt, receiptLines, linesCount, fetchingLines } = useSelector(
    (state) => state.receipt
  );
  const [search, setSearch] = useState('');
  const [filteredLines, setFilteredLines] = useState([]);

  useEffect(() => {
    if (vendorType.toLowerCase() !== 'warehouse') {
      toast.error('Purchase receipts are only available for Warehouse', {
        id: 'purchase-receipts'
      });
      navigate('/');
    }
  }, [vendorType]);

  useEffect(() => {
    setTimeout(() => {
      fetchCurrentPurchaseReceipt();
    }, 100);
  }, [id]);

  useEffect(() => {
    setTimeout(async () => {
      if (currentReceipt !== undefined) {
        await fetchCurrentReceiptLines();
      } else {
        toast.error('No PO found with Order number ' + id);
        navigate('/purchase-orders');
        await dispatch(loaderActions.hide());
      }
    }, 100);
  }, [currentReceipt]);

  async function fetchCurrentReceiptLines() {
    await dispatch(LoadReceiptLines({ companyId, filter: ` document_No eq '${id}'` }));
    await dispatch(loaderActions.hide());
  }

  async function fetchCurrentPurchaseReceipt() {
    await dispatch(loaderActions.show());
    await dispatch(LoadReceipt({ companyId, filter: `number eq '${id}'`, type: 'single' }));
  }

  useEffect(() => {
    const filtered = receiptLines.filter((line) => {
      return (
        line.description.toLowerCase().includes(search.toLowerCase()) ||
        String(line.line_No).includes(search) ||
        String(line.quantity).includes(search)
      );
    });
    setFilteredLines(filtered);
  }, [receiptLines, search]);

  const orderReceiptList = filteredLines.map((line, index) => {
    return (
      <tr key={index}>
        <td>{line.line_No}</td>
        <td>{line.no}</td>
        <td>{line.description}</td>
        <td>{line.quantity}</td>
      </tr>
    );
  });

  const ErrorCard = (
    <>
      <Alert variant="warning">
        <> No Purchase receipt lines for {id}</>
      </Alert>
    </>
  );

  const SearchErrorCard = (
    <>
      <Alert variant="warning">
        <> No Purchase receipt lines matching current search</>
      </Alert>
    </>
  );

  return (
    <div>
      {!fetchingReceipt ? (
        <div className="card shadow-sm mb-4">
          <div className="card-body">
            <div>Purchase Receipt detail</div>
            {currentReceipt && Object.keys(currentReceipt).length > 0 && (
              <Descriptions bordered size={'large'} colon={false} className="mt-2">
                <Descriptions.Item label="Purchase Order #" span={2}>
                  {currentReceipt.orderNumber}
                </Descriptions.Item>
                <Descriptions.Item label="Purchase Receipt #">
                  {currentReceipt.number}
                </Descriptions.Item>

                <Descriptions.Item label="Vendor Name" span={3}>
                  {currentReceipt.vendorName}
                </Descriptions.Item>
              </Descriptions>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
      {!fetchingLines && receiptLines.length > 0 ? (
        <div className=" shadow-sm mb-4">
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <div className="mb-3 d-flex justify-content-between">
                <div>
                  <span>
                    Purchase Receipt Lines ( {filteredLines.length} / {linesCount} )
                  </span>
                </div>
                <div className="d-flex">
                  <Form.Control
                    size="sm"
                    type="text"
                    className="mr-2"
                    placeholder="Search "
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
              {!fetchingLines &&
                (filteredLines.length > 0 ? (
                  <Table striped bordered hover responsive="sm">
                    <thead>
                      <tr>
                        <th>Line #</th>
                        <th>Sku</th>
                        <th>Description</th>
                        <th>Warehouse Posted Quantity</th>
                      </tr>
                    </thead>
                    <tbody>{orderReceiptList}</tbody>
                  </Table>
                ) : receiptLines.length > 0 ? (
                  SearchErrorCard
                ) : (
                  ErrorCard
                ))}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default PurchaseReceiptId;
